import {useEffect} from '@wordpress/element';

export const useProcessExpressCheckoutError = (
    {
        onError,
        emitResponse,
        onCheckoutFail,
        messageContext = null,
        paymentMethodId,
        activePaymentMethod,
    }) => {
    useEffect(() => {
        const unsubscribe = onCheckoutFail((data) => {
            if (data?.processingResponse.paymentDetails?.stripeErrorMessage) {
                return {
                    type: emitResponse.responseTypes.ERROR,
                    message: data.processingResponse.paymentDetails.stripeErrorMessage,
                    messageContext: messageContext || emitResponse.noticeContexts.EXPRESS_PAYMENTS
                };
            }
            if (paymentMethodId === activePaymentMethod) {
                onError('');
            }
            return null;
        });
        return () => unsubscribe();
    }, [
        onCheckoutFail,
        messageContext,
        paymentMethodId,
        activePaymentMethod,
        emitResponse.responseTypes.ERROR,
        emitResponse.noticeContexts.EXPRESS_PAYMENTS
    ]);
}